import React from 'react';

import { appMethod as app } from '@utils/app';
import { convertStyleData } from '@utils/tools';

import './TopicSortCustomComponent.less';


/**
 * type: "topic-sort" 
 * 组件：话题排序组件
 */

export default class TopicSortCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    let compindex = props.index;
    let pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {
    let {
      customFeature,
      content
    } = pageInstance.data.eles[compindex];
    // 设置param
    let param = customFeature;
    // 感觉后面topic可直接用customFeature
    pageInstance.setData({
      ['eles[' + compindex + '].param']: param
    });
    let topicCompIndex = app.findComponentIndexById(customFeature.topic_sort_object);
    if (topicCompIndex < 0) {
      app.showModal({content: '话题排序未找到绑定的话题列表'});
      pageInstance.setData({
        ['eles[' + compindex + '].currentOrderby']: 'comment_count'
      });
      return;
    }
    pageInstance.setData({
      ['eles[' + compindex + '].currentOrderby']: content[0].orderby,
      ['eles[' + compindex + '].relateTopicCompIndex']: topicCompIndex,
      ['eles[' + topicCompIndex + '.relateSortCompIndex']: compindex
    });
  }

  switchTopiclistOrderBy = (e) => {
    let dataset = e.currentTarget.dataset;
    let compindex = dataset.compindex;
    let orderby = dataset.orderby;
    let pageInstance = app.getAppCurrentPage();
    let newdata = {};
    let compData = pageInstance.data.eles[compindex];

    if (compData.relateTopicCompIndex) {
      let topicCompIndex = compData.relateTopicCompIndex;
      let topicListParam = pageInstance.data.eles[topicCompIndex].listParam;

      newdata['eles[' + compindex + '].currentOrderby'] = orderby;
      newdata['eles[' + topicCompIndex + '].listParam.orderby'] = orderby;
      newdata['eles[' + topicCompIndex + '].listStatus.loading'] = false;
      newdata['eles[' + topicCompIndex + '].listStatus.isMore'] = true;
      newdata['eles[' + topicCompIndex + '].topicList'] = [];

      if (orderby === 'distance' && !topicListParam.latitude) {
        app.getLocation({
          success: res => {
            newdata['eles[' + topicCompIndex + '].listParam.page'] = 1;
            newdata['eles[' + topicCompIndex + '].listParam.orderby'] = orderby;
            newdata['eles[' + topicCompIndex + '].listParam.latitude'] = res.latitude;
            newdata['eles[' + topicCompIndex + '].listParam.longitude'] = res.longitude;
            pageInstance.setData(newdata);
            pageInstance.callComponentMethod({
              componentIndex: topicCompIndex,
              methodName: 'getTopListData',
              argvs: [topicCompIndex, pageInstance]
            });
          }
        });
      } else {
        newdata['eles[' + topicCompIndex + '].listParam.page'] = 1;
        pageInstance.setData(newdata);
        pageInstance.callComponentMethod({
          componentIndex: topicCompIndex,
          methodName: 'getTopListData',
          argvs: [topicCompIndex, pageInstance]
        });
      }
    }else {
      app.showModal({content: '话题排序未找到绑定的话题列表'});
    }
  }

  render() {
    // 组件数据
    const data = this.props.data;
    // 组件配置对象
    const customFeature = data.customFeature;
    // 商品分类
    const content = data.content;
    // 组件样式
    const styleObj = convertStyleData(data.style);
    const selectStyle = {
      color: customFeature.selectedColor,
    }

    return (
      <div className="custom-component topic-sort" style={styleObj}>
        {content.map((item, index) => 
          <div className="sort-item" 
            key={index}
            style={item.orderby == data.currentOrderby ? selectStyle : {}}
            onClick={this.switchTopiclistOrderBy}
            data-orderby={item.orderby}
            data-order={item.order}
            data-compindex={this.props.index}
            >
          {item.text}</div>
        )}
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/custom-component/topic-sort-custom-component/TopicSortCustomComponent.jsx